"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ErrorComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const FindMyTripsErrors = ()=>{
    const { otpRequestErrorMsg } = (0, OtpContext_js_namespaceObject.useOtpContext)();
    const messageEndRef = (0, external_react_namespaceObject.useRef)(null);
    (0, external_react_namespaceObject.useEffect)(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        otpRequestErrorMsg
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            otpRequestErrorMsg ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                flexDirection: "column",
                justifyContent: "center",
                "data-testid": "try-again",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.GenericBanner, {
                    mx: 3,
                    my: 3,
                    p: 2,
                    borderRadius: "lg",
                    color: "background.light",
                    iconLeft: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.InformationOutline, {
                        color: "warning.base",
                        "data-testid": "information-outline-icon"
                    }),
                    text: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
                        textStyle: "subheading6",
                        children: [
                            otpRequestErrorMsg,
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                textStyle: "subheading6",
                                children: "Please try again."
                            })
                        ]
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                ref: messageEndRef
            })
        ]
    });
};
const ErrorComponent = FindMyTripsErrors;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
